/**
 * Normalizes `createdAt` from chat/send flows to epoch ms, or `null` if missing/invalid.
 * Used by Firebase `sendChatMsg` and live-chat queue flush so behavior stays aligned.
 */
export function getCreatedAtTimestampMs(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined) return null;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : null;
}
